
import { LucideXCircle } from "lucide-react";
import ErrorDialog from "./ErrorDialog";
import SuccessDialog from "./SuccessDialog";
import WarningDialog from "./WarningDialog";

export type AlertType = "success" | "warning" | "error";
export type AlertAction =  {
  label : string
  onClick : () => void
}

type AlertDialogProps = {
  type : AlertType,
  open: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  description?: string,
  action? : AlertAction
}

const AlertDialogs = ({ type, open, onOpenChange, title, description, action } : AlertDialogProps) => {
  if (type === "error") 
    return <ErrorDialog open={open} onOpenChange={onOpenChange} title={title} description={description}></ErrorDialog>
  else if (type === "success")
    return <SuccessDialog open={open} onOpenChange={onOpenChange} title={title} description={description}/>
  else if (type === "warning")
    return <WarningDialog open={open} onOpenChange={onOpenChange} title={title} description={description} action={action}/>
  else return null;
};

export default AlertDialogs;
